import { feature as promotionsFlowFeature } from '@central-products/promotions-flow';

export const promotionsFlowPlugin = {
  beforeBootstrap({ addBootstrapperFeature, params }) {
    const {
      supportedLangCodes,
      defaultLangCode,
      helpPageUrls,
      routingStrategy,
      vertical,
      routes,
      gameLauncher,
      epicValueCarousel,
      basename,
    } = params;
    addBootstrapperFeature(promotionsFlowFeature, {
      supportedLangCodes,
      defaultLangCode,
      helpPageUrls,
      routingStrategy,
      vertical,
      routes,
      gameLauncher,
      epicValueCarousel,
      basename,
    });
  },
};
